import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SurveyStatusRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderContent() {
    const { value } = this.props;
    if (!value) {
      return null;
    }
    return (
      <span className="label label-default">{value}</span>
    );
  }
  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

SurveyStatusRenderer.propTypes = {
  value: PropTypes.string,
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
SurveyStatusRenderer.defaultProps = {
  value: null,
  node: null,
};

export default SurveyStatusRenderer;
